import React from 'react'
import ReactMarkdown from 'react-markdown'

import jasnaLogo from '@/assets/jasnaLogo.svg'
import userIcon from '@/assets/userIcon.svg'
import { Message, MessageType } from '@/store/chat.types'

import FallbackForm from './fallback-form'

interface ChatMessageProps {
  message: Message
  email: string
  userMessage: string
  onEmailChange: (val: string) => void
  onMessageChange: (val: string) => void
  onSubmit: () => void
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  message,
  email,
  userMessage,
  onEmailChange,
  onMessageChange,
  onSubmit,
}) => (
  <div className={`flex items-start ${message.type === MessageType.Sent ? 'justify-end' : 'justify-start'}`}>
    {message.type === MessageType.Received && (
      <div className="shrink-0 mr-2">
        <div className="bg-header-bg size-8 rounded-full flex items-center justify-center">
          <img src={jasnaLogo} alt="Jasna" className="w-[22px] object-cover" />
        </div>
      </div>
    )}

    <div
      className={`rounded-xl p-4 max-w-[75%] ${
        message.type === MessageType.Sent ? 'bg-[#F4F4F4] text-[#292929]' : 'bg-header-bg text-white'
      }`}
    >
      <div className="whitespace-pre-wrap break-words text-xs">
        <ReactMarkdown
          components={{
            a: (props) => (
              <a
                {...props}
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-600 hover:text-blue-800"
              />
            ),
          }}
        >
          {message.text}
        </ReactMarkdown>
      </div>

      <div
        className={`text-xs mt-2 ${
          message.type === MessageType.Sent ? 'text-[#5E5E5E] text-right text-[8px]' : 'text-white text-[8px]'
        }`}
      >
        {message.timestamp}
      </div>

      {message.type === MessageType.Received && message.showInputFields && (
        <FallbackForm
          email={email}
          message={userMessage}
          onEmailChange={onEmailChange}
          onMessageChange={onMessageChange}
          onSubmit={onSubmit}
        />
      )}
    </div>

    {message.type === MessageType.Sent && (
      <div className="bg-[#F4F4F4] size-9 rounded-full flex items-center justify-center ml-1">
        <img src={userIcon} className="w-[14px] h-[16px] object-cover" />
      </div>
    )}
  </div>
)

export default ChatMessage
